var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarrier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_632_1160)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5156 8.3606C31.9836 9.16534 33.3102 11.1932 34.9734 13.9844H28.5156V8.3606ZM8.24829 14.2188C8.92731 14.2188 9.42017 14.5465 9.42017 15.3125C9.42017 15.9586 8.8974 16.4825 8.25165 16.4844H1.17188C0.524597 16.4844 0 17.0093 0 17.6562C0 18.3035 0.524597 18.8281 1.17188 18.8281H11.7188C12.3721 18.8281 12.8952 19.3524 12.8952 20C12.8952 20.6473 12.3706 21.1719 11.7233 21.1719H1.17188C0.524597 21.1719 0 21.6965 0 22.3438C0 22.991 0.524597 23.5156 1.17188 23.5156H3.75V27.0312C3.75 27.6785 4.2746 28.2031 4.92188 28.2031H7.27753C7.69745 30.2716 9.52515 31.7969 11.6797 31.7969C13.8342 31.7969 15.6619 30.2716 16.0818 28.2031H27.9807C28.4006 30.2716 30.2283 31.7969 32.3828 31.7969C34.5374 31.7969 36.3651 30.2716 36.785 28.2031H38.8281C39.4754 28.2031 40 27.6785 40 27.0312V20C40 16.5616 36.3733 16.3333 36.3699 16.3281H27.3438C26.6965 16.3281 26.1719 15.8035 26.1719 15.1562V8.125H4.92188C4.2746 8.125 3.75 8.6496 3.75 9.29688V11.875H2.34375C1.69647 11.875 1.17188 12.3996 1.17188 13.0469C1.17188 13.6942 1.69647 14.2188 2.34375 14.2188H8.24829ZM33.902 25.7855C34.7409 26.6245 34.7409 27.9852 33.902 28.8242C32.5525 30.1736 30.2344 29.2136 30.2344 27.3047C30.2344 25.3961 32.5525 24.436 33.902 25.7855ZM13.1989 25.7855C14.0378 26.6245 14.0378 27.9852 13.1989 28.8242C11.8494 30.1736 9.53125 29.2136 9.53125 27.3047C9.53125 25.3961 11.8494 24.436 13.1989 25.7855Z",
    fill: "#009DDD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_632_1160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrier);
export default __webpack_public_path__ + "static/media/Carrier.416e80e307064831b1f67d68639dcc90.svg";
export { ForwardRef as ReactComponent };